"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipNavContent = exports.SkipNavLink = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var skip_nav_1 = require("@reach/skip-nav");

Object.defineProperty(exports, "SkipNavContent", {
  enumerable: true,
  get: function get() {
    return skip_nav_1.SkipNavContent;
  }
});

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var Root = (0, styled_components_1.default)(skip_nav_1.SkipNavLink)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  :focus {\n    background: ", ";\n    box-shadow: ", ";\n    border-radius: 0.5rem;\n    color: ", ";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1rem;\n    max-width: calc(100vw - 1.25rem);\n    text-decoration: none;\n  }\n"], ["\n  :focus {\n    background: ", ";\n    box-shadow: ", ";\n    border-radius: 0.5rem;\n    color: ", ";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1rem;\n    max-width: calc(100vw - 1.25rem);\n    text-decoration: none;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('PLANE.SHADOWS.low', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
});

var SkipNavLink = function SkipNavLink(_a) {
  var __UIScope = _a.__UIScope,
      className = _a.className,
      children = _a.children,
      rest = tslib_1.__rest(_a, ["__UIScope", "className", "children"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'SkipNav',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement(Root, tslib_1.__assign({
    className: rootClasses
  }, rest), children);
};

exports.SkipNavLink = SkipNavLink;
var templateObject_1;